import { Card as CardCL, FaIcon, FaIcons, Icons } from "@in/component-library";
import React, { FC, ReactNode, SyntheticEvent } from "react";

interface CardProps {
  title: string;
  secondaryTitle?: string;
  rightSideActionIcon?: FaIcons | Icons;
  rightSideActionIconOnClick?: (e: SyntheticEvent) => void;
  leftSideTitleIcon?: ReactNode;
  footerContent?: string | ReactNode;
  footerLabel?: string;
  footerLabelBackground?: boolean;
  footerIcon?: string;
  href?: string;
  onClick?: (e: SyntheticEvent) => void;
  children?: ReactNode;
  className?: string;
}

const Card: FC<CardProps> = ({
  title,
  secondaryTitle,
  rightSideActionIcon = FaIcons.ArrowRight,
  rightSideActionIconOnClick,
  leftSideTitleIcon,
  footerContent,
  footerLabel,
  footerLabelBackground = false,
  footerIcon,
  href,
  onClick,
  children,
  className = ""
}: CardProps) => {
  const elementProps = href ? (onClick ? { href, onClick } : { href }) : { onClick };

  return (
    <CardCL className={"card " + className} {...elementProps} boxShadow>
      <div className="card__wrapper">
        <div className="card__content-main">
          <div>
            {leftSideTitleIcon && (
              <span className="card__icon-left">
                <FaIcon name={leftSideTitleIcon} size="1x" />
              </span>
            )}
            <span className="card__icon-right" onClick={rightSideActionIconOnClick}>
              <FaIcon name={rightSideActionIcon as FaIcons} size="1x" />
            </span>
            <h3 className="card__title"> {title} </h3>
          </div>

          <p className="card__secondary-title">{secondaryTitle}</p>
        </div>
        <div className="card__content-body">
          <div className="card__children">
            {children ? (
              children
            ) : (
              <div className="card__content">
                {footerContent}
                <div className="card__label">
                  <FaIcon className="card__label-icon" name={footerIcon} size="1x" />
                  <span className={`${footerLabelBackground ? "card__tag-bg" : "card__tag"}`}>{footerLabel}</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </CardCL>
  );
};

export default Card;
